import utils from '@/utils/utils';

export const FILTER_ALL = 0;
export const FILTER_NOT_SELLER_RESPONDED_YET = 1;
export const FILTER_SELLER_RESPONDED_OK = 2;
export const FILTER_REFUSED = 3;
export const FILTER_ADMIN_RESPONDED_FAIL = 4;
export const FILTER_EXPIRED = 9;
// 新プラン以降のステータスなので100番台
export const FILTER_INTRODUCED = 101;
export const FILTER_CONTRACT_NG = 102;
export const FILTER_APPLY_REFUSED = 103;
export const FILTER_COMMUNICATION_REFUSED = 104;

export const FILTER_TYPE_NAMES = {
  FILTER_ALL: 'すべて',
  FILTER_NOT_SELLER_RESPONDED_YET: '未回答',
  FILTER_SELLER_RESPONDED_OK_OLD_PLAN: '挙手済み',
  FILTER_SELLER_RESPONDED_OK_NEW_PLAN: '応募済み',
  FILTER_ADMIN_RESPONDED_FAIL: '選外',
  FILTER_REFUSED: '辞退',
  FILTER_APPLY_REFUSED: '辞退（応募）',
  FILTER_COMMUNICATION_REFUSED: '辞退（紹介成立後）',
  FILTER_EXPIRED: '期限切れ',
  FILTER_INTRODUCED: 'やりとり開始待ち',
  FILTER_CONTRACT_NG: 'やりとり非承諾',
};

export const FILTER_TYPES = [
  {
    id: FILTER_ALL,
    name: FILTER_TYPE_NAMES.FILTER_ALL,
  },
  {
    id: FILTER_NOT_SELLER_RESPONDED_YET,
    name: FILTER_TYPE_NAMES.FILTER_NOT_SELLER_RESPONDED_YET,
  },
  {
    id: FILTER_SELLER_RESPONDED_OK,
    name: FILTER_TYPE_NAMES.FILTER_SELLER_RESPONDED_OK_NEW_PLAN,
  },
  {
    id: FILTER_REFUSED,
    name: FILTER_TYPE_NAMES.FILTER_REFUSED,
  },
  {
    id: FILTER_ADMIN_RESPONDED_FAIL,
    name: FILTER_TYPE_NAMES.FILTER_ADMIN_RESPONDED_FAIL,
  },
  {
    id: FILTER_EXPIRED,
    name: FILTER_TYPE_NAMES.FILTER_EXPIRED,
  },
  {
    id: FILTER_INTRODUCED,
    name: FILTER_TYPE_NAMES.FILTER_INTRODUCED,
  },
  {
    id: FILTER_CONTRACT_NG,
    name: FILTER_TYPE_NAMES.FILTER_CONTRACT_NG,
  },
];

export const attachTransactionStatusForNewPlan = (transaction) => {
  // 未応募
  if (transaction.not_seller_responded_yet) {
    return {
      selectStatus: FILTER_NOT_SELLER_RESPONDED_YET,
      displayName: FILTER_TYPE_NAMES.FILTER_NOT_SELLER_RESPONDED_YET,
      backgroundColor: '#ffe9e9',
    };
  }

  // 応募済みかつ選外でない
  if (transaction.seller_responded_ok && !transaction.admin_responded_fail) {
    return {
      selectStatus: FILTER_SELLER_RESPONDED_OK,
      displayName:
        FILTER_TYPE_NAMES.FILTER_SELLER_RESPONDED_OK_NEW_PLAN +
        ' ' +
        utils.formatDate(transaction.answered_at),
      backgroundColor: '#cff2ee',
    };
  }

  // 選外
  if (transaction.admin_responded_fail) {
    return {
      selectStatus: FILTER_ADMIN_RESPONDED_FAIL,
      displayName: FILTER_TYPE_NAMES.FILTER_ADMIN_RESPONDED_FAIL,
      backgroundColor: '#f1f2f6',
    };
  }

  // 辞退（直接指名）
  if (transaction.transaction_type === 'normal' && transaction.is_refused) {
    return {
      selectStatus: FILTER_REFUSED,
      displayName:
        FILTER_TYPE_NAMES.FILTER_REFUSED +
        ' ' +
        utils.formatDate(transaction.refused_at),
      backgroundColor: '#f1f2f6',
    };
  }

  // 辞退（応募）
  if (transaction.transaction_type !== 'normal' && transaction.is_refused) {
    return {
      selectStatus: FILTER_APPLY_REFUSED,
      displayName:
        FILTER_TYPE_NAMES.FILTER_APPLY_REFUSED +
        ' ' +
        utils.formatDate(transaction.refused_at),
      backgroundColor: '#f1f2f6',
    };
  }

  // 辞退（紹介成立後）
  if (transaction.seller_communication_refused_at) {
    return {
      selectStatus: FILTER_COMMUNICATION_REFUSED,
      displayName:
        FILTER_TYPE_NAMES.FILTER_COMMUNICATION_REFUSED +
        ' ' +
        utils.formatDate(transaction.seller_communication_refused_at),
      backgroundColor: '#f1f2f6',
    };
  }

  // 紹介済み
  if (
    transaction.selecting_status === 'match' &&
    !transaction.is_communication_refused
  ) {
    return {
      selectStatus: FILTER_INTRODUCED,
      displayName: FILTER_TYPE_NAMES.FILTER_INTRODUCED,
      backgroundColor: '#cff2ee',
    };
  }

  // 失注
  if (
    transaction.selecting_status === 'match' &&
    transaction.is_communication_refused
  ) {
    return {
      selectStatus: FILTER_CONTRACT_NG,
      displayName: FILTER_TYPE_NAMES.FILTER_CONTRACT_NG,
      backgroundColor: '#f1f2f6',
    };
  }

  // 期限切れは一番最後に判断する
  if (transaction.is_expired) {
    return {
      selectStatus: FILTER_EXPIRED,
      displayName:
        '回答期限切れ' +
        ' ' +
        utils.formatDate(transaction.send_answer_expired_at),
      backgroundColor: '#f1f2f6',
    };
  }

  return {
    selectStatus: null,
    displayName: null,
    backgroundColor: null,
  };
};
